import React, { useRef, useState } from 'react';

import { CircularProgress, makeStyles, Paper, Typography } from '@material-ui/core';
import { AsyncPaginate, wrapMenuList } from 'react-select-async-paginate';
import { components } from 'react-select';
import { useLocalization } from 'contexto/localization/useLocalization';

const useStyles = makeStyles({
    title: {
        fontSize: 12,
        marginTop: -10,
        marginBottom: 15,
        marginLeft: 10,
        backgroundColor: "white",
        paddingLeft: 4,
        paddingRight: 4,
        display: "table",
        borderRadius: 5,
    },
    paper: {
        padding: 0,
    },
});

const SelectMenuButton = (props) => {
    return (
        <components.MenuList  {...props}>
            {props.children}
            {props?.isLoading && (
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '3px', paddingBottom: '3px' }}>
                    <CircularProgress size='15px'/>
                </div>
            )}
        </components.MenuList >
    );
};
const MenuList = wrapMenuList(SelectMenuButton);

const PromisePagSelect = ({ 
    name, 
    label, 
    size, 
    value,
    defaultValue, 
    disabled = false, 
    required = false, 
    isClearable = false, 
    loadOptions = async (search = "", loadedOptions, { page }) => {},
    onChange = ({ target = { name: "", label: "", value: undefined }, value = undefined }) => {},
    onLoadOptions = () => {}
}) => {
    // Idioma
    const { strings } = useLocalization();
    const styles = useStyles();
    const selectRef = useRef(null);
    const [valorActual, setValorActual] = useState({
        value: "",
        label: "",
    });

    const _onChange = (e) => {
        onChange({
            target: { name: name, label: e ? e.label : undefined, value: e ? e.value : undefined },
            value: e,
        });
        setValorActual({ value: e.value, label: e.label });
    };

    const _onLoadOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await loadOptions(search, loadedOptions, { page }, valorActual.value === "" ? defaultValue : undefined);
            if (onLoadOptions && res.options && res.options.length > 0) {
                res.options = res.options.filter(c => !loadedOptions.some(x => x.value === c.value));
                if (valorActual.value === "") {
                    onLoadOptions(res.options.find(x => x.value === defaultValue) ?? res.options[0]);
                    setValorActual(res.options.find(x => x.value === defaultValue) ?? res.options[0]);
                    if (res.additional && res.additional.page) res.additional.page = 1;
                }
            };
            return res;
        } catch (err) {
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: page + 1,
                },
            };
        }
    };

    return (
        <div>
            <Paper variant="outlined" className={styles.paper} style={{ paddingBottom: size === "small" ? 1 : 8 }}>
                <Typography className={styles.title} color="textSecondary" gutterBottom>
                    {label + (required ? " *" : "")}
                </Typography>

                <AsyncPaginate
                    selectRef={selectRef}
                    placeholder={label + (required ? " *" : "")}
                    loadOptions={_onLoadOptions}
                    additional={{
                        page: 1,
                    }}
                    debounceTimeout={600}
                    defaultOptions
                    onChange={_onChange}
                    isDisabled={disabled ? true : false}
                    noOptionsMessage={() => strings.components.sistema.sinResultados}
                    value={valorActual}
                    isClearable={isClearable ? true : false}
                    components={{ MenuList: MenuList }}
                    styles={{
                        control: (base) => ({
                            ...base,
                            border: 0,
                            boxShadow: 'none',
                            marginTop: size === "small" ? '-20px' : '-15px',
                            backgroundColor: 'unset'
                        }),
                        menu: (base) => ({
                            ...base,
                            zIndex: 999,
                        }),
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                        })
                    }}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                />
                {!disabled && required && (
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{
                            opacity: 0,
                            width: 1,
                            height: 0,
                            position: "absolute"
                        }}
                        value={value}
                        onChange={() => {}}
                        onFocus={() => selectRef?.current?.focus()}
                        required={required}
                    />
                )}
            </Paper>
        </div>
    );
};

export default PromisePagSelect;